import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { Articles } from "../types/article";
import { PiecesText } from "../Atoms/PiecesText";
import { RightArrow } from "../Atoms/Icons/RightArrow";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import {
  CenterContainer,
  FlexContainer,
  RightContainer,
} from "../styles/styles";
import { Text } from "../Atoms/Text";
import styled from "styled-components";

const ItemDivider = styled("div")`
  padding: 8px 24px 8px 0px;
`;

interface ArticleInGroupsProps {
  articles: Articles;
}

export function ArticleInGroups({ articles }: ArticleInGroupsProps) {
  const navigate = useFixaNavigate();

  const relevantArticles = articles
    .filter((a) => !!a.groupName)
    .sort((a1, a2) => (a1.groupName ?? "").localeCompare(a2.groupName ?? ""));

  const addOnContent = (
    <>
      {relevantArticles.map((article) => (
        <div
          key={article.groupId}
          onClick={() =>
            navigate(
              `/mediamaintenance/groups/${article.groupId}?mediaId=${article.mediaId}`
            )
          }
        >
          <ItemDivider>
            <FlexContainer $direction={"row"}>
              <CenterContainer $centerText={false}>
                <div style={{ display: "flex" }}>
                  <Text text={article.groupName ?? ""} bold />
                </div>
                <PiecesText pieces={article.nbrArticles} />
              </CenterContainer>
              <RightContainer>
                <RightArrow />
              </RightContainer>
            </FlexContainer>
          </ItemDivider>
        </div>
      ))}
    </>
  );

  if (relevantArticles.length === 0) return <></>;

  return <FixaListViewItem addOn={addOnContent} />;
}
